import { render, staticRenderFns } from "./AcompanhamentoTabela.vue?vue&type=template&id=c25d3d48&"
import script from "./AcompanhamentoTabela.vue?vue&type=script&lang=js&"
export * from "./AcompanhamentoTabela.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports